import { render, staticRenderFns } from "./workflowHrComplaintsTable.vue?vue&type=template&id=390ce3fa"
import script from "./workflowHrComplaintsTable.vue?vue&type=script&lang=js"
export * from "./workflowHrComplaintsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports